export const SET_SKU_DATA = "SET_SKU_DATA";

const initialState = {
  add_list_popup: false,
  sku_date: null,
  SKU_file: null,
  disable_list_add_button: false,
  sku_file_upload_percentage: 0,
  skuListInfos: [],
  isLoading: false,
  sku_list_refetch_force: false,
  sku_list_refetch: false,
  total_sku_data: 0,
  sku_data_page: 1,
  sku_data_perpage: 10,
  sku_list_search: "",
  initialSKUListLoading: true,
};

export default (state = initialState, action = {}) =>
  action.type === SET_SKU_DATA ? { ...state, ...action.payload } : state;
